import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useRef } from 'react';
import { Box } from '../Box/index.js';
import { renderProp } from '../utils/renderProp.js';
import { useElementHeight } from '../utils/useElementHeight.js';

var TreeCardContainer = function (props) {
    var children = props.children;
    var containerRef = useRef(null);
    var height = useElementHeight(containerRef);
    return (jsx(Box, __assign({ sx: {
            display: "flex",
            alignItems: "center",
        } }, { children: children &&
            renderProp({
                prop: children,
                context: { containerRef: containerRef, height: height },
            }) })));
};
TreeCardContainer.displayName = "TreeCardContainer";

export { TreeCardContainer };
//# sourceMappingURL=TreeCardContainer.js.map
